const BASE_URL = 'https://api.ipify.org?format=json'

export const fetchIpAddress = async () => {
  const response = await fetch(BASE_URL)
  const data = await response.json()
  return data
}
